// extracted by mini-css-extract-plugin
export default {"imageWrapper":"bV-z","hovered":"cV-z","hoverImage":"dV-z","mainImage":"eV-z","imageNoBackground":"fV-z","fullSizeImage":"gV-z"};